const marketingActivityGroupFragment = gql`
  fragment MarketingActivityGroupFragment on DailyMarketingActivityGroup {
    name # Name of the marketing group (e.g., "Meta ads", "Google Ads"). "sot" is a special group representing the Source of Truth.
    cost # Ad spend
    conversions # Number of ad conversions
    revenue # Revenue from ad integrations
  }
`;

const integrationEventFragment = gql`
  fragment IntegrationEventFragment on IntegrationEvent {
    id
    integrationId
    type
    subtype
    name
    description
    dateFrom
    dateTo
    createdAt
    updatedAt
  }
`;

const marketingActivityFragment = gql`
  fragment MarketingActivityFragment on DailyMarketingActivity {
    date
    orders # Number of orders for the day
    totalSales # Total sales for the day
    groups {
      ...MarketingActivityGroupFragment
    }
    events {
      ...IntegrationEventFragment
    }
  }

  ${marketingActivityGroupFragment}
  ${integrationEventFragment}
`;

const campaignFragment = gql`
  fragment CampaignFragment on Campaign {
    id
    name
    active
    updatedAt
    campaignGroups {
      id
    }
  }
`;

const campaignGroupFragment = gql`
  fragment CampaignGroupFragment on CampaignGroup {
    id
    marketingIntegrationType # Global if null
    name
    description
    campaigns {
      ...CampaignFragment
    }
  }

  ${campaignFragment}
`;

export const MARKETING_ACTIVITY_QUERY = gql`
  query MarketingActivityQuery(
    $integrationId: String!
    $dateFrom: Date!
    $dateTo: Date!
    $marketingIntegrationType: IntegrationType
  ) {
    marketingActivity(
      integrationId: $integrationId
      dateFrom: $dateFrom
      dateTo: $dateTo
      marketingIntegrationType: $marketingIntegrationType
    ) {
      data {
        ...MarketingActivityFragment
      }
      minDate
    }
  }

  ${marketingActivityFragment}
`;

export const CAMPAIGNS_QUERY = gql`
  query CampaignsQuery(
    $integrationId: String!
    $marketingIntegrationType: IntegrationType
  ) {
    campaigns(
      integrationId: $integrationId
      marketingIntegrationType: $marketingIntegrationType
    ) {
      ...CampaignFragment
    }
  }

  ${campaignFragment}
`;

export const CAMPAIGN_GROUPS_QUERY = gql`
  query CampaignGroupsQuery(
    $integrationId: String!
    $marketingIntegrationType: IntegrationType
  ) {
    campaignGroups(
      integrationId: $integrationId
      marketingIntegrationType: $marketingIntegrationType
    ) {
      ...CampaignGroupFragment
    }
  }

  ${campaignGroupFragment}
`;

export const UPSERT_CAMPAIGN_GROUP_MUTATION = gql`
  mutation UpsertCampaignGroupMutation(
    $id: String
    $integrationId: String!
    $name: String!
    $campaigns: [String!]!
    $marketingIntegrationType: IntegrationType
  ) {
    upsertCampaignGroup(
      id: $id
      integrationId: $integrationId
      name: $name
      campaigns: $campaigns
      marketingIntegrationType: $marketingIntegrationType
    ) {
      ...CampaignGroupFragment
    }
  }

  ${campaignGroupFragment}
`;

export const DELETE_CAMPAIGN_GROUP_MUTATION = gql`
  mutation DeleteCampaignGroupMutation(
    $id: String!
    $integrationId: String!
    $marketingIntegrationType: IntegrationType
  ) {
    deleteCampaignGroup(
      id: $id
      integrationId: $integrationId
      marketingIntegrationType: $marketingIntegrationType
    ) {
      ...CampaignGroupFragment
    }
  }

  ${campaignGroupFragment}
`;

export const CREATE_INTEGRATION_EVENT_MUTATION = gql`
  mutation CreateIntegrationEventMutation(
    $input: CreateIntegrationEventInput!
  ) {
    createIntegrationEvent(input: $input) {
      ...IntegrationEventFragment
    }
  }

  ${integrationEventFragment}
`;

export const UPDATE_INTEGRATION_EVENT_MUTATION = gql`
  mutation UpdateIntegrationEventMutation(
    $id: String!
    $input: UpdateIntegrationEventInput!
  ) {
    updateIntegrationEvent(id: $id, input: $input) {
      ...IntegrationEventFragment
    }
  }

  ${integrationEventFragment}
`;

export const DELETE_INTEGRATION_EVENT_MUTATION = gql`
  mutation DeleteIntegrationEventMutation($id: String!) {
    deleteIntegrationEvent(id: $id) {
      ...IntegrationEventFragment
    }
  }

  ${integrationEventFragment}
`;
